import _ from "lodash";

export function getChargeableWeight(pkg) {
  const feeShipType = pkg.OrderFeeShipType;
  if (feeShipType === 0) {
    return parseFloat(pkg.Weight) || 0;
  }
  if (feeShipType === 1) {
    return parseFloat(pkg.Volume) || 0;
  }
  if (feeShipType === 2) {
    return parseFloat(pkg.WeightByVolume) || 0;
  }
  return Math.max(parseFloat(pkg.Weight) || 0, parseFloat(pkg.WeightByVolume) || 0) || parseFloat(pkg.Weight) || 0;
}

export function getPackageTotal(pkg) {
  const chargeableWeight = getChargeableWeight(pkg);
  if (pkg.OrderFeeWeight !== undefined && pkg.OrderFeeWeight !== null && pkg.OrderFeeWeight > 0) {
    return chargeableWeight * pkg.OrderFeeWeight;
  }
  return pkg.FeeShip !== undefined && pkg.FeeShip !== null && pkg.FeeShip > 0
    ? parseFloat(pkg.FeeShip) || 0
    : chargeableWeight * 25000;
}

export function calculateLiquidationAmount(packages) {
  const groupedOrders = _.groupBy(
    (packages || []).filter(pkg => Number(pkg.OrderID) > 0),
    pkg => `${Number(pkg.PackageType) || 0}_${Number(pkg.OrderID) || 0}`
  );
  return Object.values(groupedOrders).reduce((sum, orderPackages) => {
    const remainAmount = parseFloat(orderPackages[0] && orderPackages[0].OrderRemainAmount) || 0;
    return sum + Math.max(remainAmount, 0);
  }, 0);
}
